import React from 'react';
import { TableComponentsProps } from '../table-components.props';
import { textTransformer } from '../../utils';
import {ConsumptionLabelEnum} from '../../my-vehicles.props';
import classes from './consumption-estimate.module.scss';

export const ConsumptionEstimate = ({ row }: TableComponentsProps): JSX.Element=> {
  const estimateValue = row && row.uds_consumption_estimate_value;

  return (
    <span className={row?.uds_consumption_estimate_value === ConsumptionLabelEnum.Increased ? classes.increased : ''}>
      {estimateValue ? textTransformer(' ', 'start', 1, true, estimateValue) : '-'}
    </span>
  );
};
